import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/14/thumb-landscape.jpg"

const Post14 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Dior／ブックトート／35 x26 x16cm</span>   
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          1946年にパリでオートクチュールメゾンとして創業以来、瞬く間にシャネルと並びフランスを代表するブランドとなったクリスチャン・ディオール（Christian Dior）。<br></br>創業当初から斬新なコレクションに挑み続けるディオールのバッグは、バラエティに富んだ魅力的なモデルばかり。<br></br>今回は、ラクサスで人気のディオールのブランドバッグ10選をご紹介します♪
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>レディディオール</h2>
          <p>バッグ表面に施されたカナージュ（格子）ステッチが高級感を放つ「レディ・ディオール」はディオールのアイコンバッグの一つ。発売当時、世界が注目していたファッションリーダーであるダイアナ妃が愛用していたことが話題となり、今でも根強い人気のあるモデルです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/14/2.jpg" alt="" />
            </figure>        
        </div>
        <span className="text-center">Dior／レディディオール／23 x19 x10cm</span> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/3.jpg" alt="" />
            <span className="text-center">Dior／レディディオール／17 x14 x6cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/4.jpg" alt="" />
            <span className="text-center">Dior／レディディオール／24 x20 x12cm</span> 
          </figure>          
        </div>
        <div className="text-max-width">
          <h2>サドルバッグ</h2>
          <p>馬鞍がモチーフの「サドルバッグ」は、ビヨンセや『セックス・アンド・ザ・シティ』のサラ・ジェシカ・パーカーといった世界の名だたるセレブが愛用したことで有名。一度廃盤になったものの、2018年に復刻したことで、ヴィンテージ品も売り切れるほどの人気ぶりに。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/6.jpg" alt="" />
          </figure>
        </div>       
        <span className="text-center">Dior／サドルバッグ／24 x18 x3cm</span> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/7.jpg" alt="" />
            <span className="text-center">Dior／サドルバッグ／24 x18 x4cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/8.jpg" alt="" />
            <span className="text-center">Dior／サドルバッグ／18 x16 x5cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>サドルポーチ</h2>
          <p>ブランドのアイコン「サドルバッグ」をボディバッグとして新たにアップデート。続々と新しいモデルが登場していますが、どれも今らしい小さめサイズなのがポイント。アクセサリー感覚で楽しんで、さっと身軽にお出かけできるアイテム。
          </p>
        </div> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/10.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">Dior／サドルポーチ／20 x11 x1cm</span>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/11.jpg" alt="" />
            <span className="text-center">Dior／サドルポーチ／14 x18 x4cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/12.jpg" alt="" />
            <span className="text-center">Dior／サドルフラットベルトポーチ／19 x16 x1cm</span>
          </figure>       
        </div>
        <div className="text-max-width">
          <h2>ブックトート</h2>
          <p>「ブックトート」は大容量＆キャンバス素材でデイリーに使いやすく、持つだけでいつものスタイルをアップデートしてくれる人気アイテム。イタリアの工房で37時間以上をかけ制作されており、ステッチの種類は150万以上。サイズはミニ/S/Lの３展開なので、生活スタイルに合わせてお好みのものを選んでみては？</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/13.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/14.jpg" alt="" />
          </figure>
        </div>          
        <span className="text-center">Dior／ブックトート／42 x35 x17cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/15.jpg" alt="" />
            <span className="text-center">Dior／ブックトート／42 x35 x16cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/16.jpg" alt="" />
            <span className="text-center">Dior／ブックトート／36 x27 x16cm</span> 
          </figure>
        </div>   
        <Link to="https://laxus.co/app/pc/bags/dior" className="view-all-button">
          ディオールのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>30（トロント） モンテーニュ</h2>
          <p>2019年5月にデビューした「30（トロント） モンテーニュ」は、ディオールの新たなアイコンバッグ。スクエア型の端正なフォルムにロゴをかたどったクロージャーが上品。新作として登場したフルフラップタイプは、よりミニマルな印象に。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/14/17.jpg" alt="" />
        </figure>
        <span className="text-center">Dior／30モンテーニュナノポーチ／13 x8 x4cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/18.jpg" alt="" />
            <span className="text-center">Dior／30モンテーニュナノポーチ／13 x8 x4cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/19.jpg" alt="" />
            <span className="text-center">Dior／30モンテーニュ ボックスバッグ／17 x12 x5cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
        <h2>ボビー</h2>
        <p>半月型のシルエットとフラップ中央のバックルがキュートな「ボビー」。可愛らしいデザインの通り、その名前はクリスチャン・ディオールの愛犬の名前に由来するそう。背面のフラップ上部には“30 MONTAIGNE”の刻印があしらわれ、職人技が光る一品。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/14/20.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/21.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/22.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Dior／ボビーミディアムバッグ／19 x16 x6cm</span>  
        <div className="text-max-width">
          <h2>バニティ</h2>
          <p>円筒形のシルエットが可愛い「ヴァニティ」。付属のショルダーストラップを付ければクロスボディーバッグとしてもお使いいただけます。サイズはマイクロ/Sの2展開。マイクロサイズは手のひらに乗るほどの小さなサイズ感。Sサイズも小ぶりながら大きめのスマートフォンを収納できます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/23.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/24.jpg" alt="" />
          </figure>          
        </div>  
        <span className="text-center">Dior／スモールヴァニティ／18 x13 x10cm</span>       
        <Link to="https://laxus.co/app/pc/bags/dior" className="view-all-button">
          ディオールのバッグを見る
        </Link>                     
        <div className="text-max-width">
          <h2>オブリーク メッセンジャー</h2>
          <p>ディオールのメンズラインの中でも特に人気なのが「オブリーク」のメッセンジャーバッグ。ウィメンズと比べるとかっちりとしたフォルムが特徴的ですが、オプリークの華やかさでジェンダーレスに楽しめるデザインに仕上がっています。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/25.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/26.jpg" alt="" />
          </figure>          
        </div>  
        <span className="text-center">Dior／サファリ／22 x15 x5cm</span>          
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/27.jpg" alt="" />
            <span className="text-center">Dior／ローラーミニメッセンジャーバッグ／17 x11 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/28.jpg" alt="" />
            <span className="text-center">Dior／メッセンジャーポーチ／14 x18 x6cm</span> 
          </figure>
        </div>  
        <div className="text-max-width">
          <h2>ミスディオール</h2>
          <p>香水に始まり、アクセサリーやシューズなど、ディオールにとって特別な意味を持つアイテムにのみ名付けられてきた「ミス・ディオール」。かっちりとしたボックス型のフォルムと、サイドにつけられた細めのチェーンがフェミニンな印象を演出してくれます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/29.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/30.jpg" alt="" />
          </figure>
        </div> 
        <span className="text-center">Dior／ニューロック／25 x14 x6cm</span>          
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/31.jpg" alt="" />
            <span className="text-center">Dior／ニューロック／25 x15 x7cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/32.jpg" alt="" />
            <span className="text-center">Dior／ショルダーバッグ／26 x15 x10cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ディオラマ</h2>
          <p>2015年にクリエイティブ・ディレクター ラフ・シモンズによって発表された「ディオラマ」。シンプルでベーシックなデザインから幾何学模様、アニマルパターンを取り入れたものまで様々なデザイン展開が魅力。フェミニンなディオールでは珍しい先鋭的なデザインが楽しめる一品です。</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/33.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/34.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Dior／ディオラマ／25 x15 x7cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/35.jpg" alt="" />
            <span className="text-center">Dior／ディオラマ／18 x11 x3cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/14/36.jpg" alt="" />
            <span className="text-center">Dior／ディオラマ／25 x15 x5cm</span> 
          </figure>
        </div>  
        <div className="text-two-cloumn">
          <h2>世代を超えて愛され続ける<br className="pc"></br>ディオールのバッグ</h2>
          <p>様々なバリエーションのモデルが楽しめ、コーデにラグジュアリーな印象をプラスしてくれるディオールのバッグは時代を超えて多くの女性から愛され続けています。ラクサスでも多数のバッグを取り扱っていますので、ぜひオシャレの参考に覗いてみてくださいね♪</p>
        </div>                                      
        <Link to="https://laxus.co/app/pc/bags/dior" className="view-all-button">
          ディオールのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post14

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 14}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
